import React, { useMemo } from 'react';
import { Button } from '../common/Button';
import { PERMISSIONS } from '../../utils/constants';

interface PermissionsFormProps {
  initial?: string[];
  isSubmitting?: boolean;
  onSubmit: (permissions: string[]) => Promise<void>;
}

export const PermissionsForm: React.FC<PermissionsFormProps> = ({ initial = [], isSubmitting, onSubmit }) => {
  const [selected, setSelected] = React.useState<string[]>(initial);

  const permissionList = useMemo(() => Object.values(PERMISSIONS), []);

  const toggle = (perm: string) => {
    setSelected((prev) => (prev.includes(perm) ? prev.filter((p) => p !== perm) : [...prev, perm]));
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(selected);
      }}
      className="space-y-4"
    >
      <div className="grid grid-cols-2 gap-3">
        {permissionList.map((perm) => (
          <label key={perm} className="inline-flex items-center gap-2">
            <input type="checkbox" checked={selected.includes(perm)} onChange={() => toggle(perm)} />
            <span className="text-sm text-gray-700">{perm}</span>
          </label>
        ))}
      </div>
      <div className="flex justify-end">
        <Button type="submit" isLoading={isSubmitting}>
          Save Permissions
        </Button>
      </div>
    </form>
  );
};